import { getAustraliaAppendixLink } from "./supportAustralia";

export type SupportCardLink = {
  label: string;
  url: string;
};

type SupportCardLinkSource = {
  body?: string | null;
  link_url?: string | null;
  link_label?: string | null;
};

type SupportCardLinkContext = {
  countryCode?: string | null;
  postcode?: string | null;
};

const EXACT_LINKS_BY_LABEL: Record<string, string> = {
  ACAS: "https://www.acas.org.uk",
  "ACAS — Discrimination and grievances": "https://www.acas.org.uk/discrimination-and-the-law",
  "ACAS — Flexible working": "https://www.acas.org.uk/making-a-flexible-working-request",
  "ACAS — Time off for dependants": "https://www.acas.org.uk/time-off-for-dependants",
  "Childcare Choices": "https://www.childcarechoices.gov.uk",
  "Childcare Choices — Tax-Free Childcare": "https://www.childcarechoices.gov.uk/how-to-use-tax-free-childcare",
  "Citizens Advice": "https://www.citizensadvice.org.uk",
  "Citizens Advice — Housing": "https://www.citizensadvice.org.uk/housing",
  "Citizens Advice — Rent arrears": "https://www.citizensadvice.org.uk/housing/paying-rent/help-with-rent-arrears",
  "Citizens Advice — Repairs in rented housing":
    "https://www.citizensadvice.org.uk/housing/renting-privately/during-your-tenancy/dealing-with-repairs",
  "Community Legal Centres Australia — Find legal help": "https://clcs.org.au/",
  "Healthy Start": "https://www.healthystart.nhs.uk",
  "Housing Australia — Home Guarantee Scheme":
    "https://www.housingaustralia.gov.au/home-guarantee-scheme/help-buy-scheme",
  "Lifeline": "https://www.lifeline.org.au/",
  MoneyHelper: "https://www.moneyhelper.org.uk",
  "MoneyHelper — Budget planner": "https://www.moneyhelper.org.uk/en/everyday-money/budgeting/budget-planner",
  "MoneyHelper — Buying a home":
    "https://www.moneyhelper.org.uk/en/homes/buying-a-home/buying-a-home-a-moneyhelper-guide",
  "Moneysmart — Bills and concessions": "https://moneysmart.gov.au/managing-debt",
  "Moneysmart — Budgeting": "https://moneysmart.gov.au/budgeting/budget-planner",
  "Moneysmart — No Interest Loans": "https://moneysmart.gov.au/loans/no-interest-loans",
  "Moneysmart — Superannuation": "https://moneysmart.gov.au/how-super-works",
  "Moneysmart — Wills and powers of attorney": "https://moneysmart.gov.au/",
  "National Debt Helpline — Emergency assistance":
    "https://ndh.org.au/debt-solutions/emergency-assistance/",
  "National Legal Aid — Find legal help":
    "https://nationallegalaid.org.au/find-legal-help",
  "Passport Office — Child alerts": "https://www.passports.gov.au/help/child-alerts",
  "Passport Office — Parental consent": "https://www.passports.gov.au/consent",
  Ofgem: "https://www.ofgem.gov.uk",
  Samaritans: "https://www.samaritans.org",
  "Services Australia — Child Care Subsidy":
    "https://www.servicesaustralia.gov.au/child-care-subsidy",
  "Services Australia — Child Support":
    "https://www.servicesaustralia.gov.au/child-support",
  "Services Australia — Crisis Payment":
    "https://www.servicesaustralia.gov.au/crisis-payment",
  "Services Australia — Family Tax Benefit":
    "https://www.servicesaustralia.gov.au/family-tax-benefit",
  "Services Australia — Low Income Health Care Card":
    "https://www.servicesaustralia.gov.au/low-income-health-care-card",
  "Services Australia — Parenting Payment":
    "https://www.servicesaustralia.gov.au/parenting-payment",
  "Services Australia — Parental Leave Pay":
    "https://www.servicesaustralia.gov.au/parental-leave-pay",
  "Services Australia — Rent Assistance":
    "https://www.servicesaustralia.gov.au/rent-assistance",
  "Services Australia — Support for carers":
    "https://www.servicesaustralia.gov.au/getting-payment-if-youre-carer",
  "Starting Blocks": "https://startingblocks.gov.au/",
  "Family Relationships Online": "https://www.familyrelationships.gov.au/find-local-help",
  "FCFCOA — Parenting orders":
    "https://www.fcfcoa.gov.au/fl/hdi/apply-parenting-orders",
  "FCFCOA — Separation and divorce":
    "https://www.fcfcoa.gov.au/fl/ss-overview",
  "Fair Work — Casual and part-time work":
    "https://www.fairwork.gov.au/starting-employment/types-of-employees",
  "Fair Work — Family and domestic violence leave":
    "https://www.fairwork.gov.au/leave/family-and-domestic-violence-leave",
  "Fair Work — Flexible working arrangements":
    "https://www.fairwork.gov.au/employment-conditions/flexibility-in-the-workplace/flexible-working-arrangements",
  "Fair Work — Parental leave":
    "https://www.fairwork.gov.au/leave/parental-leave",
  "Fair Work — Pay, awards and entitlements":
    "https://www.fairwork.gov.au/pay-and-wages",
  "Fair Work — Redundancy and final pay":
    "https://www.fairwork.gov.au/ending-employment/redundancy",
  "Fair Work — Sick and carer’s leave":
    "https://www.fairwork.gov.au/leave/sick-and-carers-leave",
  "Fair Work — Workplace protections and discrimination":
    "https://www.fairwork.gov.au/employment-conditions/protections-at-work",
  "Disability Standards for Education":
    "https://www.education.gov.au/disability-standards-education-2005",
  "NDIS — Education and school supports":
    "https://ourguidelines.ndis.gov.au/how-ndis-supports-work-menu/mainstream-and-community-supports/how-do-we-work-out-who-should-fund-or-provide-your-supports",
  "Medicare Mental Health":
    "https://www.medicarementalhealth.gov.au/",
  "healthdirect — ADHD and autism":
    "https://www.healthdirect.gov.au/search-results?q=adhd%20autism",
  "healthdirect — Learning difficulties":
    "https://www.healthdirect.gov.au/search-results?q=learning%20difficulties%20dyslexia%20dyscalculia",
  "healthdirect — Mental health and wellbeing":
    "https://www.healthdirect.gov.au/search-results?q=mental%20health%20burnout%20sleep%20stress",
  "1800RESPECT": "https://www.1800respect.org.au/",
  "business.gov.au — Business structure and registrations":
    "https://business.gov.au/registrations",
  "ATO — Record keeping for business":
    "https://www.ato.gov.au/businesses-and-organisations/income-deductions-and-concessions/keeping-records",
  "Work and Income": "https://www.workandincome.govt.nz/",
  "Inland Revenue": "https://www.ird.govt.nz/",
  "Tenancy Services": "https://www.tenancy.govt.nz/",
  "Ministry of Justice": "https://www.justice.govt.nz/family/",
  "Employment New Zealand": "https://www.employment.govt.nz/",
  "Ministry of Education": "https://www.education.govt.nz/parents-and-caregivers/",
  "Health New Zealand": "https://info.health.nz/",
  "Disability Support Services": "https://www.disabilitysupport.govt.nz/",
  Sorted: "https://sorted.org.nz/",
  MoneyTalks: "https://www.moneytalks.co.nz/",
  "New Zealand Government": "https://www.govt.nz/",
  "New Zealand Passports": "https://www.passports.govt.nz/",
  "1737": "https://1737.org.nz/",
  "Parent Help": "https://www.parenthelp.org.nz/parenting-helpline/",
  "PlunketLine":
    "https://www.plunket.org.nz/about-plunket/what-we-offer/plunketline/",
  "Parent to Parent": "https://parent2parent.org.nz/",
  "ADHD New Zealand": "https://www.adhd.org.nz/",
  "Community Law": "https://communitylaw.org.nz/",
  "Citizens Advice Bureau": "https://www.cab.org.nz/",
  "Are You OK": "https://www.areyouok.org.nz/",
  "Family Services Directory": "https://www.familyservices.govt.nz/directory/",
  ACC: "https://www.acc.co.nz/",
  "business.govt.nz": "https://www.business.govt.nz/",
  Shout: "https://giveusashout.org",
  StepChange: "https://www.stepchange.org",
  Turn2us: "https://www.turn2us.org.uk",
};

const SEARCH_PROVIDERS = [
  {
    prefixes: ["GOV.UK"],
    buildUrl: (query: string) =>
      `https://www.gov.uk/search/all?keywords=${encodeURIComponent(query)}`,
  },
  {
    prefixes: ["gov.wales", "GOV.WALES"],
    buildUrl: (query: string) =>
      `https://www.gov.wales/search?keywords=${encodeURIComponent(query)}`,
  },
  {
    prefixes: ["mygov.scot"],
    buildUrl: (query: string) =>
      `https://www.mygov.scot/search?q=${encodeURIComponent(query)}`,
  },
  {
    prefixes: ["nidirect", "nidirect /", "nidirect / Labour Relations Agency"],
    buildUrl: (query: string) =>
      `https://www.nidirect.gov.uk/search?query=${encodeURIComponent(query)}`,
  },
];

const normalizeOfficialRouteLine = (line: string) =>
  line.replace(/^[-•]\s*/, "").trim();

export const extractSupportCardOfficialRouteLabels = (
  body?: string | null,
): string[] => {
  if (!body) {
    return [];
  }

  const officialRoutesIndex = body.indexOf("Official routes:");
  if (officialRoutesIndex === -1) {
    return [];
  }

  return body
    .slice(officialRoutesIndex + "Official routes:".length)
    .split("\n")
    .map((line) => normalizeOfficialRouteLine(line))
    .filter(Boolean);
};

const buildOfficialRouteLink = (
  label: string,
  context?: SupportCardLinkContext,
): SupportCardLink | null => {
  const australiaAppendixLink =
    context?.countryCode === "AU"
      ? getAustraliaAppendixLink(label, context.postcode)
      : null;
  if (australiaAppendixLink) {
    return australiaAppendixLink;
  }

  const exact = EXACT_LINKS_BY_LABEL[label];
  if (exact) {
    return { label, url: exact };
  }

  for (const provider of SEARCH_PROVIDERS) {
    const matchedPrefix = provider.prefixes.find((prefix) =>
      label.startsWith(prefix),
    );
    if (!matchedPrefix) {
      continue;
    }

    const topic = label
      .slice(matchedPrefix.length)
      .replace(/^\/\s*/, "")
      .replace(/^—\s*/, "")
      .trim();

    return { label, url: provider.buildUrl(topic || label) };
  }

  return null;
};

export const buildSupportCardLinks = (
  card: SupportCardLinkSource,
  context?: SupportCardLinkContext,
): SupportCardLink[] => {
  const derivedLinks = extractSupportCardOfficialRouteLabels(card.body)
    .map((label) => {
      const link = buildOfficialRouteLink(label, context);
      return link ?? null;
    })
    .filter((link): link is SupportCardLink => Boolean(link));

  if (derivedLinks.length > 0) {
    return derivedLinks;
  }

  if (card.link_url) {
    return [
      {
        label: card.link_label?.trim() || "Find out more",
        url: card.link_url,
      },
    ];
  }

  return [];
};
